import { Command } from "./Command";
import GpxGeoJson from "./GpxGeoJson";

export default class RestoreCachedGpxAlreadyRetrievedCommand extends Command {
  gpx: GpxGeoJson
  constructor(gpx: GpxGeoJson) {
    super();
    this.gpx = gpx;
  }
}